import { useQuery } from "@tanstack/react-query";
import { axiosCompanyInstance } from "src/config/axios";
import { StationConfiguration } from "../types/Station";

export const RQ_STATION_CONFIGURATION_KEY = "STATION_CONFIGURATION_KEY";

export type StationConfigurationResponse = StationConfiguration;

export const useStationConfiguration = (stationId: string) => {
    return useQuery({
        queryKey: [RQ_STATION_CONFIGURATION_KEY, stationId],
        queryFn: async (): Promise<StationConfigurationResponse | null> => {
            if (stationId) {
                const res = await axiosCompanyInstance.get(`station/${stationId}/configuration`);

                return res?.data;
            }
            return null;
        },
        enabled: false,
    });
};
